<style scoped>
.results-card {
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.tabs-card {
  border-top-right-radius: 0 !important;
}
</style>

<template>
  <div>
    <div v-if="tip" class="d-flex mt-4 mb-n1">
      <v-spacer />
      <v-card class="pl-4 results-card" flat outlined>
        <anchor-results-display :text="tip" />
      </v-card>
    </div>
    <v-card
      flat
      outlined
      :class="{
        'tabs-card': !!tip,
        'mt-4': !tip,
      }"
    >
      <slot />
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    tip: String,
  },
};
</script>
